import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './EditHomeLayout.resolver';
import EditHomeLayout from './EditHomeLayout';

export default async(resolver, { context: RootStoreContext })(EditHomeLayout);
